import Vue from 'vue';
export default () => {
  new Vue({
    el: '#copy-check-results-index',
    data: {
      page: 'web-like',
    },
  });
};
